import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CellphoneComponent from "./Cellphone.component";
import * as commonData from "data/common.data";
import * as MyApi from "api/student/v2/my.api";
import * as AuthApi from "api/common/Auth.api";
import { checkCellphoneOnlyNumber } from "helpers/Reg.helper";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const CellphoneContainer = () => {
    const navigate = useNavigate();
    const [isInit, setIsInit] = useState<boolean>(false);
    const [countryPhoneCode, setCountryPhoneCode] = useState<string>("");
    const [cellphone, setCellphone] = useState<string>("");
    const [newCountryPhoneCode, setNewCountryPhoneCode] = useState<string>("");
    const [newCellphone, setNewCellphone] = useState<string>("");
    const [verifyingNumber, setVerifyingNumber] = useState<string | null>(null);
    const [isOnSedingVerifyNumber, setIsOnSedingVerifyNumber] = useState<boolean>(false);
    const [hasSentVerifyNumber, setHasSentVerifyNumber] = useState<boolean>(false);
    const [verifyingId, setVerifyingId] = useState<string>("");
    const [hasVerified, setHasVerified] = useState<boolean>(false);
    const [orderedCountryPhoneCodeList, setOrderedCountryPhoneCodeList] = useState<any[]>([]);

    const init = async () => {
        const resultData = await MyApi.getCellphone();
        if (resultData.cellphone && resultData.countryPhoneCode) {
            setCellphone(resultData.cellphone);
            setCountryPhoneCode(resultData.countryPhoneCode);
        }
        
        const orderedList = commonData.getOrderedCountryPhoneCodeListWithCountryNames();
        setOrderedCountryPhoneCodeList(orderedList);
        setIsInit(true);
    };

    const handleSendVerifyNumber = async () => {
        console.log("handleSendVerifyNumber");
        if (isOnSedingVerifyNumber) {
            return;
        }

        if (!newCountryPhoneCode) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errNoCountryPhoneCode"));
            return;
        } else if (!newCellphone) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errNoCellphone"));
            return;
        } else if (!checkCellphoneOnlyNumber(newCellphone)) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errInvalidCellphone"));
            return;
        } else if (newCellphone === cellphone) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errSameCellphone"));
            return;
        }

        setIsOnSedingVerifyNumber(true);
        const data = await AuthApi.sendSmsVerifyingNumber(newCountryPhoneCode, newCellphone);
        if (data?.id) {
            setVerifyingId(data.id);
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.txtVerifyNumberSent"));
        }

        setIsOnSedingVerifyNumber(false);
    };

    const handleVerifyNumber = async () => {
        console.log("handleVerifyNumber");
        if (!verifyingId) {
            return;
        }

        if (!verifyingNumber) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errNoVerifyNumber"));
            return;
        }

        const data = await AuthApi.verifySmsVerifyingNumber(verifyingId, verifyingNumber);
        console.log({ data });
        if (data?.result) {
            setHasVerified(true);
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.txtVerifySuccess"));
        }
    };

    const handleSave = async () => {
        console.log("handleSave");
        if (!hasVerified) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.errNotVerified"));
            return;
        }

        const data = await AuthApi.updateStudentCellphone(verifyingId, newCountryPhoneCode, newCellphone);
        if (data?.result) {
            window.alert(getLanguageValue(PAGE_TYPE.STUDENT, "myChangeCellphone.txtUpdateSuccess"));
            navigate(-1);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return <CellphoneComponent
        countryPhoneCode={countryPhoneCode}
        setCountryPhoneCode={setCountryPhoneCode}
        cellphone={cellphone}
        setCellphone={setCellphone}
        newCountryPhoneCode={newCountryPhoneCode}
        setNewCountryPhoneCode={setNewCountryPhoneCode}
        newCellphone={newCellphone}
        setNewCellphone={setNewCellphone}
        verifyingId={verifyingId}
        verifyingNumber={verifyingNumber}
        setVerifyingNumber={setVerifyingNumber}
        countryPhoneCodeList={orderedCountryPhoneCodeList}
        onSendVerifyNumber={handleSendVerifyNumber}
        onVerifyNumber={handleVerifyNumber}
        isOnSedingVerifyNumber={isOnSedingVerifyNumber}
        hasSentVerifyNumber={hasSentVerifyNumber}
        hasVerified={hasVerified}
        onSave={handleSave}
    />;
};

export default CellphoneContainer;